import { render, staticRenderFns } from "./FeaturePromoWarnings.vue?vue&type=template&id=8cdf38e6"
import script from "./FeaturePromoWarnings.vue?vue&type=script&lang=js"
export * from "./FeaturePromoWarnings.vue?vue&type=script&lang=js"
import style0 from "./FeaturePromoWarnings.vue?vue&type=style&index=0&id=8cdf38e6&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3631569496/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8cdf38e6')) {
      api.createRecord('8cdf38e6', component.options)
    } else {
      api.reload('8cdf38e6', component.options)
    }
    module.hot.accept("./FeaturePromoWarnings.vue?vue&type=template&id=8cdf38e6", function () {
      api.rerender('8cdf38e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/features/promotions/FeaturePromoWarnings.vue"
export default component.exports